/** Words and colour for our focused-front readout (§1.13): the in-world caption at the push. */
import type { FrontReadout } from '@sa/sim';
import { COLORS, type RGB } from '../theme';

export interface FrontCaption {
  /** "ADVANCING", "STALLED", "LOSING" (the edge's animation shows how fast) */
  text: string;
  col: RGB;
  a: number;
}

/** Null without a focus or with nothing to push (`none`). */
export function frontCaption(f: FrontReadout): FrontCaption | null {
  switch (f.status) {
    case 'advancing':
      return { text: 'ADVANCING', col: COLORS.me, a: 0.95 };
    case 'losing':
      return { text: 'LOSING', col: COLORS.losing, a: 0.95 };
    case 'stalled':
      return { text: 'STALLED', col: COLORS.neutral, a: 0.75 };
    default:
      return null;
  }
}
